
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dhl-luggage-shipping",
      function () {
        return require("private-next-pages/dhl-luggage-shipping/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dhl-luggage-shipping"])
      });
    }
  